import { get } from "../../utills/BaseService";

export async function getPerformanceAndOption(dispatch: any, input: any): Promise<any> {
    return await get(dispatch, '/subKpi/getSubKpiWithPerformanceAndOption', input, undefined);
 };